// @ts-nocheck
import React, { FC, useEffect } from 'react';

import { isProd } from 'helpers';

export const YMetrika: FC = () => {
  useEffect(() => {
    if (!isProd) {
      return;
    }

    (function (m, e, t, r, i, k, a) {
      m[i] =
        m[i] ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (m[i].a = m[i].a || []).push(arguments);
        };
      m[i].l = 1 * new Date();
      (k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a);
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

    ym(85187644, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    });

    ym(88977299, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    });
  }, []);

  return (
    <>
      {isProd ? (
        <noscript>
          <div>
            <img
              src='https://mc.yandex.ru/watch/85187644'
              style={{ position: 'absolute', left: '-9999px' }}
              alt=''
            />
            <img
              src='https://mc.yandex.ru/watch/88977299'
              style={{ position: 'absolute', left: '-9999px' }}
              alt=''
            />
          </div>
        </noscript>
      ) : null}
    </>
  );
};
